import { makeFrameworkTypesQuickFetchKey } from './cacheKeys';
import { fetchFrameworkTypes } from './frameworkTypes';
import { wrapPromise } from 'persist-promise/wrapPromise';

export const persistedFetchFrameworkTypes = wrapPromise({
  namespace: 'FDSR',
  entityName: 'frameworkTypes',
  deepFreeze: true,
  toCacheKey: makeFrameworkTypesQuickFetchKey,
  fetch: fetchFrameworkTypes,
});
